import { render } from "./Chapter.vue?vue&type=template&id=f04b0aae&scoped=true"
import script from "./Chapter.vue?vue&type=script&lang=js"
export * from "./Chapter.vue?vue&type=script&lang=js"

import "./Chapter.vue?vue&type=style&index=0&id=f04b0aae&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f04b0aae"]])

export default __exports__